import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

export const useMotePermissionsMutation = moteId => {
  return useGenericRequestHandler({
    route: `v1/m/updatePermissions/${moteId}`,
    enabled: Boolean(moteId),
    method: 'POST'
  })
}
